import { useState, MouseEvent } from "react";
import { useHistory } from "react-router";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import CityResponseModel from "../../../models/admin/city/response/CityResponseModel";
import CityRequestModel from "../../../models/admin/city/request/CityRequestModel";
import { useAppSelector } from "../../../context-store";
import { PageModeEnum } from "../../../models/enums/PageModeEnum";

interface CityGridProps {
    cityList: CityResponseModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    onCityAction: (row: CityRequestModel, actionType: string) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
};

const CityGridComponent = (props: CityGridProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);

    const editCity = (row: CityResponseModel) => {
        if (loggedInUser !== null) {
            let cityRequestModel: CityRequestModel = {
                cityId: row.cityId,
                cityName: row.cityName,
                description: row.description,
                countryId: row.countryId,
                userId: loggedInUser?.userId
            }
            props.onCityAction(cityRequestModel, PageModeEnum.Edit);
        }
    };

    const columnsCity = [
        { key: "CityName", text: "City Name", sort: true, searchable: false },
        { key: "Description", text: "Description", sort: true, searchable: false },
        { key: "Country", text: "Country", sort: true, searchable: false },
        { key: "Actions", text: "Actions", sort: false, searchable: false }
    ];

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsCity.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.cityList.map((city: CityResponseModel, index) => (
                                <TableRow>
                                    <TableCell>{city.cityName}</TableCell>
                                    <TableCell>{city.description}</TableCell>
                                    <TableCell>{city.countryName}</TableCell>
                                    <TableCell>
                                        <a onClick={() => { editCity(city); }} title="Edit">
                                            <i className="far fa-edit grid-icon blue"></i>
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
};
export default CityGridComponent;